module.exports = __webpack_public_path__ + "static/media/tubitak_logo.5a54b0f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tubitak_logo.svg
// module id = 134
// module chunks = 0